// extracted by mini-css-extract-plugin
module.exports = {"row":"Testimonials-module--row--NOsSH","testimonialsContent":"Testimonials-module--testimonials-content--2zNqA","testimonialsRows":"Testimonials-module--testimonials-rows--1cO7O"};